"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3570],{

/***/ 36707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RA": function() { return /* binding */ verifyAuth; },
/* harmony export */   "bG": function() { return /* binding */ sendAuthOtp; },
/* harmony export */   "et": function() { return /* binding */ getUserProfile; },
/* harmony export */   "kS": function() { return /* binding */ logout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61619);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);






/**
 * send otp to verify mobile number for authentication
 * @param mobileNo target mobile number
 * @param lang otp langauge message
 * @returns reference number otp and is found user in retail platform flag
 */ var sendAuthOtp = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(mobileNo, lang) {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("/api/retail/auth/send-otp", {
                            mobileNo: mobileNo
                        }, {
                            headers: {
                                "Accept-Language": lang
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function sendAuthOtp(mobileNo, lang) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * get user profile from access token in cookies
 * @returns user's profile
 */ var getUserProfile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().get("/api/retail/auth/user/me")
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getUserProfile() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Function to verify authentication.
 * @return atk, rtk, isAlreadyRegistered and expired datetime
 */ var verifyAuth = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(payload) {
        var res, result, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("/api/retail/auth/login", payload)
                    ];
                case 1:
                    res = _state.sent();
                    result = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, res.data), {
                        timestamp: res.headers.date
                    });
                    return [
                        2,
                        result
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function verifyAuth(payload) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * logout by access token in cookies
 * @returns empty object
 */ var logout = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("/api/retail/auth/logout", {}, {
                            withCredentials: true,
                            headers: {
                                credentials: "same-origin"
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function logout() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 11787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getConsentsByCode; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20414);
/* harmony import */ var _http_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55642);
/* eslint-disable import/prefer-default-export */ 


/**
 *get all consents by lang
 * @param code consent code
 * @param lang consent language
 * @returns consents
 */ var getConsentsByCode = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(code, lang) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _http_client__WEBPACK_IMPORTED_MODULE_2__/* .clientHttpInstance.get */ .hL.get("/consent/".concat(code), {
                            headers: {
                                "Accept-Language": lang
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data.data
                    ];
            }
        });
    });
    return function getConsentsByCode(code, lang) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 50101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ updateUser; },
/* harmony export */   "r": function() { return /* binding */ createUser; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61619);




/**
 * register retail user
 * @returns user details
 */ var createUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("/api/retail/users", {})
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function createUser() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * update user
 * @returns user details
 */ var updateUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(payload) {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().put("/api/retail/users", payload)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function updateUser(payload) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 78993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cv": function() { return /* binding */ ErrorModal; },
/* harmony export */   "D": function() { return /* binding */ ErrorModalBody; },
/* harmony export */   "Fj": function() { return /* binding */ LoginModalBody; },
/* harmony export */   "Mm": function() { return /* binding */ SubmitButton; },
/* harmony export */   "Pe": function() { return /* binding */ WelcomeModal; },
/* harmony export */   "Tw": function() { return /* binding */ CloseIcon; },
/* harmony export */   "_A": function() { return /* binding */ LoginModal; },
/* harmony export */   "cv": function() { return /* binding */ WelcomeBanner; },
/* harmony export */   "gQ": function() { return /* binding */ ButtonTitle; },
/* harmony export */   "h4": function() { return /* binding */ CancelModal; },
/* harmony export */   "kU": function() { return /* binding */ CancelModalBody; },
/* harmony export */   "l0": function() { return /* binding */ Form; },
/* harmony export */   "r6": function() { return /* binding */ ModalTitle; },
/* harmony export */   "t_": function() { return /* binding */ WelcomeModalBody; },
/* harmony export */   "xJ": function() { return /* binding */ FormItem; },
/* harmony export */   "z7": function() { return /* binding */ WelcomeBannerImage; }
/* harmony export */ });
/* unused harmony exports CheckOutlined, Verified, OtpFormItem, LoginModalContent, ModalCloseIcon, ResendButton, ResendWait */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35865);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96422);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71230);
/* harmony import */ var src_styles_globals__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60082);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63606);
/* harmony import */ var styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94698);
/* harmony import */ var styled_breakpoints__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Common_LinkTitle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(37262);
/* harmony import */ var _Common_Form_Form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82601);
/* harmony import */ var _Common_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55267);
/* harmony import */ var _Common_ErrorDialog__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87418);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #1c7c4e;\n  font-weight: bold;\n  font-size: 17px;\n  line-height: 18px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 10px;\n  color: #1c7c4e;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 48px;\n  width: 100%;\n  padding: 0px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .sunday-component-form-item {\n    margin: 0px;\n    height: auto;\n  }\n  ",
        " {\n    max-width: ",
        ";\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 444px;\n  .ant-modal-content {\n    border-radius: 16px;\n    overflow: hidden;\n  }\n  .ant-modal-close {\n    margin-top: 8px;\n  }\n  .ant-modal-header {\n  }\n  .ant-modal-body {\n    padding: 16px;\n  }\n  .ant-modal-footer {\n    padding: 16px;\n  }\n  ",
        " {\n    top: 0;\n    margin: 0px;\n    padding: 0px;\n    .ant-modal,\n    .ant-modal-content {\n      height: 100vh;\n      width: 100vw;\n      margin: 0;\n      top: 0;\n    }\n    .ant-modal-footer {\n      position: fixed;\n      bottom: 0;\n      width: 100%;\n      background: white;\n    }\n    .ant-modal-content {\n      border-radius: 0px;\n    }\n    .ant-modal-body {\n      overflow: auto;\n      padding-top: 16px;\n      padding-bottom: 24px;\n      height: calc(100vh - 60px);\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  display: flex;\n  items: center;\n  width: 24px;\n  height: 100%;\n  right: 0;\n  top: 0;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  row-gap: 16px;\n  ",
        " {\n    max-width: ",
        ";\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 4px;\n  cursor: pointer;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  margin-top: 4px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 444px;\n  .ant-modal-content {\n    border-radius: 16px;\n    overflow: hidden;\n  }\n  .ant-modal-close {\n    margin-top: 8px;\n  }\n  .ant-modal-header {\n    display: flex;\n    justify-content: center;\n  }\n  .ant-modal-body {\n    text-align: center;\n    padding: 16px;\n  }\n  .ant-modal-footer {\n    display: flex;\n    flex-direction: column;\n    row-gap: 8px;\n  }\n  ",
        " {\n    max-width: 300px;\n    .ant-modal-title {\n      max-width: 200px;\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 444px;\n  .ant-modal-content {\n    border-radius: 16px;\n    overflow: hidden;\n  }\n  .ant-modal-header {\n  }\n  .ant-modal-body {\n    padding: 0px;\n    text-align: center;\n  }\n  .ant-modal-footer {\n    display: flex;\n    flex-direction: column;\n    row-gap: 8px;\n  }\n  .ant-image {\n    bottom: 4px;\n  }\n  ",
        " {\n    max-width: 300px;\n    .ant-image {\n      bottom: 2px;\n    }\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px;\n  color: ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  align-items: end;\n  justify-content: center;\n  background-image: url("/static/pages/registerOtp/register-welcome-bg.svg");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 250px;\n  border-radius: 0% 0% 100% 100% / 0% 0% 20% 20%;\n  overflow: hidden;\n  ',
        " {\n    height: 155px;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  max-height: 205px;\n  border-radius: 0% 0% 100% 100% / 0% 0% 10% 10%;\n  ",
        " {\n    max-height: 134px;\n    border-radius: 0% 0% 100% 100% / 0% 0% 5% 5%;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 8px;\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}










var maxContentWidth = "343px";
var CheckOutlined = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fad07398-0"
})(_templateObject());
var Verified = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.Title).attrs({
    level: 9
}).withConfig({
    componentId: "sc-fad07398-1"
})(_templateObject1());
var SubmitButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Common_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fad07398-2"
})(_templateObject2());
var Form = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Common_Form_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fad07398-3"
})(_templateObject3(), (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.down)("lg"), maxContentWidth);
var FormItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.FormItem).withConfig({
    componentId: "sc-fad07398-4"
})(_templateObject4());
var OtpFormItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.FormItem).withConfig({
    componentId: "sc-fad07398-5"
})(_templateObject5());
var LoginModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fad07398-6"
})(_templateObject6(), (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.down)("lg"));
var LoginModalContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fad07398-7"
})(_templateObject7());
var ModalTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.Title).attrs({
    level: 5
}).withConfig({
    componentId: "sc-fad07398-8"
})(_templateObject8(), src_styles_globals__WEBPACK_IMPORTED_MODULE_8__/* .color.charcoal10 */ .$.charcoal10);
var ModalCloseIcon = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fad07398-9"
})(_templateObject9());
var CloseIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fad07398-10"
})(_templateObject10());
var LoginModalBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-fad07398-11"
})(_templateObject11(), src_styles_globals__WEBPACK_IMPORTED_MODULE_8__/* .color.charcoal09 */ .$.charcoal09, (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.down)("lg"), maxContentWidth);
var ButtonTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-fad07398-12"
})(_templateObject12());
var ResendButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Common_LinkTitle__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).attrs({
    level: 7
}).withConfig({
    componentId: "sc-fad07398-13"
})(_templateObject13());
var ResendWait = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-fad07398-14"
})(_templateObject14(), src_styles_globals__WEBPACK_IMPORTED_MODULE_8__/* .color.charcoal09 */ .$.charcoal09);
var CancelModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fad07398-15"
})(_templateObject15(), (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.down)("md"));
var CancelModalBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-fad07398-16"
})(_templateObject16(), src_styles_globals__WEBPACK_IMPORTED_MODULE_8__/* .color.charcoal09 */ .$.charcoal09);
var WelcomeModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fad07398-17"
})(_templateObject17(), (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.down)("md"));
var WelcomeModalBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-fad07398-18"
})(_templateObject18(), src_styles_globals__WEBPACK_IMPORTED_MODULE_8__/* .color.charcoal09 */ .$.charcoal09);
var WelcomeBanner = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fad07398-19"
})(_templateObject19(), (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.down)("md"));
var WelcomeBannerImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fad07398-20"
})(_templateObject20(), (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.down)("md"));
var ErrorModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Common_ErrorDialog__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fad07398-21"
})(_templateObject21());
var ErrorModalBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-fad07398-22"
})(_templateObject22(), src_styles_globals__WEBPACK_IMPORTED_MODULE_8__/* .color.charcoal09 */ .$.charcoal09);


/***/ }),

/***/ 87418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71230);
/* harmony import */ var antd_lib_grid_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60872);
/* harmony import */ var antd_lib_modal_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83663);
/* harmony import */ var src_styles_globals__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60082);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55267);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 8px;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 8px;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 8px;\n  p,\n  div {\n    font-size: 21px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    border-radius: 12px;\n  }\n  .ant-modal-header {\n    border-radius: 12px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 56px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}








var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Title).attrs({
    level: 5
}).withConfig({
    componentId: "sc-76691922-0"
})(_templateObject(), src_styles_globals__WEBPACK_IMPORTED_MODULE_4__/* .color.charcoal10 */ .$.charcoal10);
var Body = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-76691922-1"
})(_templateObject1(), src_styles_globals__WEBPACK_IMPORTED_MODULE_4__/* .color.charcoal10 */ .$.charcoal10);
var ButtonGroup = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-76691922-2"
})(_templateObject2());
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
    fullWidth: true
}).withConfig({
    componentId: "sc-76691922-3"
})(_templateObject3());
var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd_lib_modal_Modal__WEBPACK_IMPORTED_MODULE_6__["default"]).withConfig({
    componentId: "sc-76691922-4"
})(_templateObject4());
var Image = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-76691922-5"
})(_templateObject5());
var ErrorDialog = function(param) {
    var title = param.title, description = param.description, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, _errorButtons = param.errorButtons, errorButtons = _errorButtons === void 0 ? [] : _errorButtons, icon = param.icon, width = param.width;
    var sm = (0,antd_lib_grid_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().sm;
    var defaultWidth = sm ? "303px" : "auto";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Modal, {
        width: width !== null && width !== void 0 ? width : defaultWidth,
        visible: isVisible,
        footer: null,
        closable: false,
        "data-testid": "error-dialog-modal",
        "data-gtm-input-code": "error-dialog-modal",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                justify: "center",
                children: icon || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Image, {
                    src: "/static/common/x-circle.svg"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                children: title
            }),
            typeof description === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Body, {
                children: description
            }) : description,
            errorButtons.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonGroup, {
                children: errorButtons.map(function(param, index) {
                    var text = param.text, onClick = param.onClick, _type = param.type, type = _type === void 0 ? "primary" : _type;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                        "data-testid": "error-dialog-button-".concat(index),
                        "data-gtm-input-code": "error-dialog-button-".concat(index),
                        onClick: onClick,
                        type: type,
                        children: text
                    }, text);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorDialog);


/***/ }),

/***/ 82601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _AutoCompleteForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47947);
/* harmony import */ var _CheckBoxForm__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96250);
/* harmony import */ var _ChipGroupForm__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44976);
/* harmony import */ var _DatePickerForm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18154);
/* harmony import */ var _RadioGroupForm__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67058);
/* harmony import */ var _TextAreaForm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23138);
/* harmony import */ var _TextBoxForm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71085);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & {\n    label {\n      color: var(--ui-form-input-text-activated-label_text-color) !important;\n    }\n  }\n  .sunday-component-form-item-with-help {\n    label {\n      color: var(--ui-form-input-text-error-label_text-color) !important;\n    }\n  }\n  label.sunday-component-form-item-required::before {\n    color: var(--ui-form-input-text-error-helper_text-color) !important;\n  }\n  .sunday-component-form-item-explain {\n    color: var(--ui-form-input-text-error-helper_text-color) !important;\n  }\n  .sunday-component-form-item-has-error {\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var Form = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.Form).withConfig({
    componentId: "sc-e3cf461-0"
})(_templateObject(), _TextBoxForm__WEBPACK_IMPORTED_MODULE_3__/* .TextBoxErrorCss */ .Zn, _AutoCompleteForm__WEBPACK_IMPORTED_MODULE_4__/* .AutoCompleteErrorCss */ .gB, _DatePickerForm__WEBPACK_IMPORTED_MODULE_5__/* .DatePickerErrorCss */ .N3, _TextAreaForm__WEBPACK_IMPORTED_MODULE_6__/* .TextAreaErrorCss */ .$i, _ChipGroupForm__WEBPACK_IMPORTED_MODULE_7__/* .ChipGroupErrorCss */ .kC, _RadioGroupForm__WEBPACK_IMPORTED_MODULE_8__/* .RadioGroupErrorCss */ .H7, _CheckBoxForm__WEBPACK_IMPORTED_MODULE_9__/* .CheckBoxErrorCss */ .sr);
/* harmony default export */ __webpack_exports__["Z"] = (Form);


/***/ }),

/***/ 67058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H7": function() { return /* binding */ RadioGroupErrorCss; },
/* harmony export */   "Mc": function() { return /* binding */ RadioGroupErrorText; }
/* harmony export */ });
/* unused harmony exports RadioGroupLabelText, RadioGroupHelperText */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_2__);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: var(--ui-form-radio_buttons-label-enabled-label_radio_buttons-color);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: var(--ui-form-radio_buttons-helper-error-helper_radio_buttons-color);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: var(--ui-form-radio_buttons-helper-enabled-helper_radio_buttons-color);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    color: var(--ui-form-radio_buttons-label-error-label_radio_buttons-color);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var RadioGroupLabelText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-d9b3ca8-0"
})(_templateObject());
var RadioGroupErrorText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-d9b3ca8-1"
})(_templateObject1());
var RadioGroupHelperText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-d9b3ca8-2"
})(_templateObject2());
var RadioGroupErrorCss = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), RadioGroupLabelText);
var Container = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d9b3ca8-3"
})(_templateObject4());
var RadioGroupForm = function(_param) {
    var label = _param.label, helperText = _param.helperText, errorText = _param.errorText, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _isError = _param.isError, isError = _isError === void 0 ? false : _isError, props = _object_without_properties(_param, [
        "label",
        "helperText",
        "errorText",
        "disabled",
        "isError"
    ]);
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(RadioGroupLabelText, {
                children: label
            }),
            /*#__PURE__*/ _jsx(RadioGroup, _object_spread({
                disabled: disabled
            }, props)),
            isError && /*#__PURE__*/ _jsx(RadioGroupErrorText, {
                children: errorText
            }),
            /*#__PURE__*/ _jsx(RadioGroupHelperText, {
                children: helperText
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (RadioGroupForm)));


/***/ }),

/***/ 23138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$i": function() { return /* binding */ TextAreaErrorCss; },
/* harmony export */   "Ux": function() { return /* binding */ TextAreaErrorText; }
/* harmony export */ });
/* unused harmony exports TextBoxOptionalText, TextAreaLabelText, TextAreaHelperText */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var src_styles_globals__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60082);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _TextArea__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17189);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline;\n  // move color to config later\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: var(--ui-form-input-text_area-activated-label_text_area-color);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: var(--ui-form-input-text_area-error-helper_text_area-color);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: var(--ui-form-input-text_area-activated-helper_text_area-color);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    color: var(--ui-form-input-text_area-error-label_text_area-color);\n  }\n  ",
        ":not(.sunday-component-input-disabled) {\n    background-color: var(--ui-form-input-text_area-error-background-color);\n    color: var(--ui-form-input-text_area-activated-fields_text_area-color);\n    border-color: var(--ui-form-input-text_area-error-border-color);\n    ::placeholder {\n      color: var(--ui-form-input-text_area-error-placeholder_text_area-color);\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var TextBoxOptionalText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-e41ac9d0-0"
})(_templateObject(), src_styles_globals__WEBPACK_IMPORTED_MODULE_4__/* .color.charcoal07 */ .$.charcoal07);
var TextAreaLabelText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-e41ac9d0-1"
})(_templateObject1());
var TextAreaErrorText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-e41ac9d0-2"
})(_templateObject2());
var TextAreaHelperText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-e41ac9d0-3"
})(_templateObject3());
var TextAreaErrorCss = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), TextAreaLabelText, _TextArea__WEBPACK_IMPORTED_MODULE_5__/* .CustomTextArea */ .K);
var Container = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return props;
}).withConfig({
    componentId: "sc-e41ac9d0-4"
})(_templateObject5(), function(props) {
    return !props.disabled && ":hover {\n    ".concat(TextAreaLabelText, " {\n      color: var(--ui-form-input-text_area-hover-label_text_area-color);\n    }\n    ").concat(TextAreaHelperText, " {\n      color: var(--ui-form-input-text_area-hover-helper_text_area-color);\n    }\n  }\n\n  :focus-within {\n    ").concat(TextAreaLabelText, " {\n      color: var(--ui-form-input-text_area-focused-label_text_area-color);\n    }\n    ").concat(TextAreaHelperText, " {\n      color: var(--ui-form-input-text_area-focused-helper_text_area-color);\n    }\n  }");
}, function(props) {
    return props.isError && TextAreaErrorCss;
}, function(props) {
    return props.disabled && "\n  ".concat(TextAreaLabelText, " {\n    color: var(--ui-form-input-text_area-disabled-label_text_area-color);\n  }\n  ").concat(TextAreaHelperText, " {\n    color: var(--ui-form-input-text_area-disabled-helper_text_area-color);\n  }\n  ");
});
var TextAreaForm = function(_param) {
    var label = _param.label, helperText = _param.helperText, errorText = _param.errorText, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _isError = _param.isError, isError = _isError === void 0 ? false : _isError, optionalText = _param.optionalText, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "label",
        "helperText",
        "errorText",
        "disabled",
        "isError",
        "optionalText"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
        disabled: disabled,
        isError: isError,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TextAreaLabelText, {
                children: [
                    label,
                    " ",
                    optionalText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextBoxOptionalText, {
                        children: optionalText
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_TextArea__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                disabled: disabled
            }, props)),
            isError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextAreaErrorText, {
                children: errorText
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextAreaHelperText, {
                children: helperText
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (TextAreaForm);


/***/ }),

/***/ 37262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_1__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline;\n  color: var(--ui-form-button-text-enabled-text-color);\n\n  &:hover {\n    color: var(--ui-form-button-text-hover-text-color);\n    text-decoration: var(--ui-form-button-text-hover-text-decoration);\n    text-decoration-color: var(--ui-form-button-text-hover-text-color);\n  }\n  &:focus {\n    color: var(--ui-form-button-text-focused-text-color);\n    text-decoration: var(--ui-form-button-text-focused-text-decoration);\n    text-decoration-color: var(--ui-form-button-text-focused-text-color);\n  }\n  &:disabled {\n    color: var(--ui-form-button-text-disabled-text-color);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var LinkTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.Title).withConfig({
    componentId: "sc-6a3c49dd-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (LinkTitle);


/***/ }),

/***/ 17189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CustomTextArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_2__);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: var(--ui-form-input-text_area-activated-background-color);\n  color: var(--ui-form-input-text_area-activated-fields_text_area-color);\n  caret-color: var(--ui-form-input-text_area-activated-fields_text_area-color);\n  border-color: var(--ui-form-input-text_area-activated-border-color);\n  ::placeholder {\n    color: var(--ui-form-input-text_area-activated-placeholder_text_area-color);\n  }\n\n  :not(.sunday-component-input-disabled) {\n    :hover {\n      background-color: var(--ui-form-input-text_area-hover-background-color);\n      border-color: var(--ui-form-input-text_area-hover-border-color);\n      ::placeholder {\n        color: var(--ui-form-input-text_area-hover-placeholder_text_area-color);\n      }\n    }\n    :focus {\n      background-color: var(--ui-form-input-text_area-focused-background-color);\n      border-color: var(--ui-form-input-text_area-focused-border-color);\n      box-shadow: 0 0 0 2px var(--ui-form-input-text_area-focused-border-shadow);\n      ::placeholder {\n        color: var(\n          --ui-form-input-text_area-focused-placeholder_text_area-color\n        );\n      }\n    }\n  }\n\n  &.sunday-component-input-disabled {\n    color: var(--ui-form-input-text_area-disabled-fields_text_area-color);\n    background-color: var(\n      --ui-form-input-text_area-disabled-background-color\n    ) !important;\n    border-color: var(\n      --ui-form-input-text_area-disabled-border-color\n    ) !important;\n    ::placeholder {\n      color: var(\n        --ui-form-input-text_area-disabled-placeholder_text_area-color\n      );\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var CustomTextArea = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.TextArea).withConfig({
    componentId: "sc-91fc8a45-0"
})(_templateObject());
var TextArea = function(_param) /*#__PURE__*/ {
    var _dataTestId = _param.dataTestId, dataTestId = _dataTestId === void 0 ? "" : _dataTestId, _size = _param.size, size = _size === void 0 ? "large" : _size, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _defaultValue = _param.defaultValue, defaultValue = _defaultValue === void 0 ? null : _defaultValue, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, _onClick = _param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, _autoSize = _param.autoSize, autoSize = _autoSize === void 0 ? true : _autoSize, _rows = _param.rows, rows = _rows === void 0 ? 1 : _rows, prop = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "dataTestId",
        "size",
        "placeholder",
        "defaultValue",
        "disabled",
        "onChange",
        "onClick",
        "autoSize",
        "rows"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomTextArea, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        "data-testid": dataTestId,
        "data-gtm-input-code": dataTestId,
        size: size,
        placeholder: placeholder,
        defaultValue: defaultValue,
        onChange: onChange,
        onClick: onClick,
        disabled: disabled,
        autoSize: autoSize,
        rows: rows
    }, prop));
};
/* harmony default export */ __webpack_exports__["Z"] = (TextArea);


/***/ }),

/***/ 7949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35865);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96422);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(41080);
/* harmony import */ var styled_breakpoints__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94698);
/* harmony import */ var styled_breakpoints__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styled_breakpoints__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26793);
/* harmony import */ var src_utils_errors__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63197);
/* harmony import */ var src_utils_logger__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(14744);
/* harmony import */ var antd_lib_grid_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60872);
/* harmony import */ var _styles_globals__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60082);
/* harmony import */ var _api_consent__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11787);
/* harmony import */ var _Common_Button__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(55267);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 100vw;\n  .ant-modal-content {\n    border-radius: 16px;\n    overflow: hidden;\n  }\n  .ant-modal-header {\n  }\n  .ant-modal-close {\n    margin-top: 10px;\n  }\n  .ant-modal-body {\n    padding: 20px 16px;\n    height: 70vh;\n    background-color: ",
        ";\n    overflow: auto;\n  }\n  .ant-modal-footer {\n    display: ",
        ";\n    width: 100%;\n    background-color: ",
        ";\n  }\n  ",
        " {\n    top: 0;\n    margin: 0px;\n    padding: 0px;\n    width: 100% !important;\n    .ant-modal,\n    .ant-modal-content {\n      border-radius: 0px !important;\n      height: 100vh;\n      width: 100vw;\n      margin: 0;\n      top: 0;\n    }\n    .ant-modal-body {\n      overflow: auto;\n      height: calc(100vh - 141px);\n    }\n    .ant-modal-footer {\n      padding: 16px;\n      position: fixed;\n      bottom: 0;\n      width: 100%;\n      background: white;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d875668d-0"
})(_templateObject(), _styles_globals__WEBPACK_IMPORTED_MODULE_7__/* .color.charcoal01 */ .$.charcoal01, function(props) {
    return props.footer ? "block" : "none";
}, _styles_globals__WEBPACK_IMPORTED_MODULE_7__/* .color.white */ .$.white, (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_3__.down)("lg"));
var CloseIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d875668d-1"
})(_templateObject1());
var ModalBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Body).withConfig({
    componentId: "sc-d875668d-2"
})(_templateObject2(), _styles_globals__WEBPACK_IMPORTED_MODULE_7__/* .color.charcoal09 */ .$.charcoal09);
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Title).withConfig({
    componentId: "sc-d875668d-3"
})(_templateObject3(), _styles_globals__WEBPACK_IMPORTED_MODULE_7__/* .color.charcoal10 */ .$.charcoal10);
var ConsentModal = function(param) {
    var _title = param.title, title = _title === void 0 ? "" : _title, _code = param.code, code = _code === void 0 ? "" : _code, _visible = param.visible, visible = _visible === void 0 ? false : _visible, _onCloseModal = param.onCloseModal, onCloseModal = _onCloseModal === void 0 ? function() {} : _onCloseModal, _lang = param.lang, lang = _lang === void 0 ? "en" : _lang, _footer = param.footer, footer = _footer === void 0 ? null : _footer;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$)("application-page").t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), description = ref[0], setDescription = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isLoadingError = ref2[0], setIsLoadingError = ref2[1];
    var isMounted = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(false);
    var lg = (0,antd_lib_grid_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)().lg;
    var onDisplayConsent = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
            var consent, error, isUnknowError;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        setIsLoadingError(false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setDescription("");
                        return [
                            4,
                            (0,_api_consent__WEBPACK_IMPORTED_MODULE_13__/* .getConsentsByCode */ .v)(code, lang)
                        ];
                    case 2:
                        consent = _state.sent();
                        if (!consent) {
                            setIsLoadingError(true);
                        }
                        setIsLoadingError(false);
                        setDescription(consent.detail);
                        setIsLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setIsLoading(false);
                        setIsLoadingError(true);
                        isUnknowError = (0,src_utils_errors__WEBPACK_IMPORTED_MODULE_14__/* .checkUnknownError */ .t)(error);
                        if (isUnknowError) {
                            (0,src_utils_logger__WEBPACK_IMPORTED_MODULE_15__/* .logError */ .H)("[consent-modal-component] display consent fail", {
                                code: code,
                                lang: lang
                            }, error);
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onDisplayConsent() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (isMounted.current && visible) {
            onDisplayConsent();
        }
        isMounted.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visible
    ]);
    var styles = {
        modalTitle: {
            minHeight: "24px",
            margin: "0px 56px"
        },
        noDataLogo: {
            height: "144px",
            marginBottom: "17px"
        },
        errorBox: {
            width: "255px",
            margin: "28px auto"
        },
        errorMessage: {
            marginBottom: "17px",
            margin: "0px auto 17px auto"
        },
        errorMessageTitle: {
            marginButton: "8px"
        },
        refreshButton: {
            width: "172px"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Modal, {
        centered: lg,
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
            level: 6,
            style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                textAlign: "center"
            }, styles.modalTitle),
            children: title
        }),
        footer: footer,
        visible: visible,
        closeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CloseIcon, {
            preview: false,
            src: "/static/pages/planPage/x-icon.svg",
            alt: "close-icon",
            onClick: function() {
                return onCloseModal();
            }
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                loading: isLoading,
                active: true,
                title: false,
                paragraph: {
                    rows: 15,
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ModalBody, {
                    level: 7,
                    children: description
                })
            }),
            isLoadingError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                    textAlign: "center"
                }, styles.errorBox),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        src: "/static/pages/applicationPage/consent-no-data-icon.svg",
                        preview: false,
                        style: styles.noDataLogo
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                            textAlign: "center"
                        }, styles.errorMessage),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                                level: 5,
                                children: t("agreementForm.errorMessage.loadingError.title")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ModalBody, {
                                level: 7,
                                children: t("agreementForm.errorMessage.loadingError.description")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Common_Button__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        type: "outlined",
                        onClick: function() {
                            return onDisplayConsent();
                        },
                        style: styles.refreshButton,
                        children: t("agreementForm.errorMessage.loadingError.refreshButton")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ConsentModal);


/***/ }),

/***/ 43250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A6": function() { return /* binding */ CONSENT_ADDITIONAL_INFO_TYPE; },
/* harmony export */   "Q4": function() { return /* binding */ QUESTIONNAIRE_CODE; },
/* harmony export */   "Qb": function() { return /* binding */ PARENT_RELATION_OPTION_VALUE; },
/* harmony export */   "qL": function() { return /* binding */ BENEFICIARY_RELATION_OPTION_VALUE; },
/* harmony export */   "sw": function() { return /* binding */ CONSENT_TYPE; },
/* harmony export */   "xM": function() { return /* binding */ CONSENT_CODE; }
/* harmony export */ });
var QUESTIONNAIRE_CODE = {
    YES_NO_ONCE: "YES_NO_ONCE",
    YES_NO_HAVE: "YES_NO_HAVE",
    YES_NO_INTENTION: "YES_NO_INTENTION",
    ONLY_REMARK: "ONLY_REMARK",
    YES_NO_ONCE_OPTIONAL: "YES_NO_ONCE_OPTIONAL",
    YES_NO_HAVE_OPTIONAL: "YES_NO_HAVE_OPTIONAL",
    YES_NO_INTENTION_OPTIONAL: "YES_NO_INTENTION_OPTIONAL",
    ONLY_REMARK_OPTIONAL: "ONLY_REMARK_OPTIONAL"
};
var CONSENT_CODE = {
    SUNDAY_MKT: "SUNDAY_MKT",
    SUNDAY_TC: "SUNDAY_TC",
    SUNDAY_PRIVACY: "SUNDAY_PRIVACY"
};
var CONSENT_TYPE = {
    CHECKBOX: "CHECKBOX",
    PRODUCT_TC: "PRODUCT_TC",
    INSURER_PRIVACY: "INSURER_PRIVACY",
    SUNDAY_TC: "SUNDAY_TC",
    SUNDAY_MKT: "SUNDAY_MKT",
    TRUSTFUL_TC: "TRUSTFUL_TC",
    PRODUCT_V1_TC: "PRODUCT_V1_TC",
    PASSIVE_TEXT_ONLY: "PASSIVE_TEXT_ONLY"
};
var CONSENT_ADDITIONAL_INFO_TYPE = {
    PDF: "PDF",
    DIALOG: "DIALOG",
    NONE: "NONE"
};
var PARENT_RELATION_OPTION_VALUE = [
    "FATHER",
    "MOTHER",
    "ELDER_SIBLING", 
];
var BENEFICIARY_RELATION_OPTION_VALUE = [
    "FATHER",
    "MOTHER",
    "ELDER_SIBLING",
    "SIBLING",
    "CHILD",
    "SPOUSE",
    "FIANCEE", 
];


/***/ }),

/***/ 28216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ GRANT_TYPE; }
/* harmony export */ });
var GRANT_TYPE = {
    OTP: "otp",
    REFRESH_TOKEN: "refresh_token"
};


/***/ }),

/***/ 3378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ OTP_METHOD; }
/* harmony export */ });
/* unused harmony export VERIFY_KEY */
var OTP_METHOD = {
    SMS: "SMS",
    EMAIL: "email"
};
var VERIFY_KEY = (/* unused pure expression or super */ null && ("018de577-4ff6-77a2-88ed-198fb30f04cf" || 0));


/***/ }),

/***/ 62090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QQ": function() { return /* binding */ MOTOR_INSURED_FORM_PARAMS; },
/* harmony export */   "Vs": function() { return /* binding */ ENTRY_FORM_PARAMS; },
/* harmony export */   "Yz": function() { return /* binding */ UTM_PARAMS; },
/* harmony export */   "gH": function() { return /* binding */ CAR_INFO_ENTRY_FORM_PARAMS; },
/* harmony export */   "g_": function() { return /* binding */ GLOBAL_PARAMS; },
/* harmony export */   "lF": function() { return /* binding */ IS_DIRECTED; },
/* harmony export */   "qh": function() { return /* binding */ GLOBAL_PARAMS_FOR_RENEWAL; },
/* harmony export */   "zP": function() { return /* binding */ S_REF_CODE; }
/* harmony export */ });
/* unused harmony exports UTM_PARAMS_LIST, POLICY_INFO_PARAMS */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);
/* eslint-disable import/prefer-default-export */ 
var UTM_PARAMS = {
    UTM_SOURCE: "utm_source",
    UTM_MEDIUM: "utm_medium",
    UTM_CAMPAIGN: "utm_campaign",
    UTM_TERM: "utm_term",
    UTM_CONTENT: "utm_content"
};
var UTM_PARAMS_LIST = [
    UTM_PARAMS.UTM_SOURCE,
    UTM_PARAMS.UTM_MEDIUM,
    UTM_PARAMS.UTM_CAMPAIGN,
    UTM_PARAMS.UTM_TERM,
    UTM_PARAMS.UTM_CONTENT, 
];
var S_REF_CODE = "sRefCode";
var GLOBAL_PARAMS = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UTM_PARAMS_LIST).concat([
    S_REF_CODE,
    "apTraceId",
    "crmSfId", 
]);
var GLOBAL_PARAMS_FOR_RENEWAL = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UTM_PARAMS_LIST).concat([
    S_REF_CODE,
    "apTraceId",
    "renewalCode", 
]);
var ENTRY_FORM_PARAMS = [
    "insuredDateOfBirth",
    "effectiveDate",
    "insuredGender",
    "maritalStatus", 
];
var CAR_INFO_ENTRY_FORM_PARAMS = [
    "carMake",
    "recommendItems",
    "carYear",
    "carModel",
    "carTrim",
    "purpose", 
];
var MOTOR_INSURED_FORM_PARAMS = [
    "insuredDateOfBirth",
    "zipcode"
];
var POLICY_INFO_PARAMS = (/* unused pure expression or super */ null && ([
    "purpose",
    "isWhiteLicensePlate",
    "effectiveDate",
    "interestedPolicyType", 
]));
var IS_DIRECTED = "isDirected";


/***/ }),

/***/ 66885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ convertObjectToInputFields; },
/* harmony export */   "$S": function() { return /* binding */ handleOnKeyPressNumberEvent; },
/* harmony export */   "sP": function() { return /* binding */ handleOnPasteNumberEvent; }
/* harmony export */ });
var convertObjectToInputFields = function(obj) {
    var ref;
    return (ref = Object.keys(obj)) === null || ref === void 0 ? void 0 : ref.map(function(key) {
        return {
            inputCode: key,
            value: obj[key]
        };
    });
};
var handleOnKeyPressNumberEvent = function(event) {
    [
        "e",
        "E",
        "+",
        "-"
    ].includes(event.key) && event.preventDefault();
};
var handleOnPasteNumberEvent = function(event) {
    var ref;
    event.preventDefault();
    document.execCommand("insertText", false, (ref = event.clipboardData) === null || ref === void 0 ? void 0 : ref.getData("text").replace(/\D/g, ""));
};


/***/ }),

/***/ 63197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ checkUnknownError; }
/* harmony export */ });
/* harmony import */ var src_constants_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74092);
/* eslint-disable import/prefer-default-export */ 
/**
 * check is unknown error.
 * @param error error object any type.
 * @returns true if error is unknown error and false when it's known error.
 */ var checkUnknownError = function(error) {
    return (error === null || error === void 0 ? void 0 : error.code) === src_constants_error__WEBPACK_IMPORTED_MODULE_0__/* .ERROR_CODE.TECHNICAL_ERROR */ .B.TECHNICAL_ERROR || !(error === null || error === void 0 ? void 0 : error.code) || typeof error.code !== "string" || !Object.keys(src_constants_error__WEBPACK_IMPORTED_MODULE_0__/* .BUSINESS_ERROR_CODE */ .b).find(function(errorKey) {
        return src_constants_error__WEBPACK_IMPORTED_MODULE_0__/* .BUSINESS_ERROR_CODE */ .b[errorKey] === error.code;
    }) && !((error === null || error === void 0 ? void 0 : error.code) === src_constants_error__WEBPACK_IMPORTED_MODULE_0__/* .ERROR_CODE.AUTHENTICATION_ERROR */ .B.AUTHENTICATION_ERROR);
};


/***/ }),

/***/ 6767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IC": function() { return /* binding */ formatMobileNumber; },
/* harmony export */   "OJ": function() { return /* binding */ formatNumberToThaiCurrency; },
/* harmony export */   "jS": function() { return /* binding */ formatMobileNumberToInternal; }
/* harmony export */ });
/* unused harmony exports formatMobileNumberStartWithTwoDigitAreaCode, snakeToCamelCase */
/**
 * Formats a mobile number by adding separators.
 *
 * @param {string} mobileNo - The mobile number to be formatted.
 * @param {string} separator - The separator to be added between the different parts of the mobile number. Defaults to a space.
 * @return {string} The formatted mobile number.
 */ var formatMobileNumber = function(mobileNo) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " ";
    // Remove any non-digit characters from the input string
    var cleanedNumber = mobileNo === null || mobileNo === void 0 ? void 0 : mobileNo.replace(/\D/g, "");
    if ((cleanedNumber === null || cleanedNumber === void 0 ? void 0 : cleanedNumber.length) !== 10) {
        return mobileNo;
    }
    var head = cleanedNumber.slice(0, 3);
    var middle = cleanedNumber.slice(3, 6);
    var tail = cleanedNumber.slice(6);
    var formattedNumber = "".concat(head).concat(separator).concat(middle).concat(separator).concat(tail);
    return formattedNumber;
};
var formatMobileNumberStartWithTwoDigitAreaCode = function(mobileNo) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " ";
    // Remove any non-digit characters from the input string
    var cleanedNumber = mobileNo === null || mobileNo === void 0 ? void 0 : mobileNo.replace(/\D/g, "");
    if ((cleanedNumber === null || cleanedNumber === void 0 ? void 0 : cleanedNumber.length) !== 10) {
        return mobileNo;
    }
    var head = cleanedNumber.slice(0, 2);
    var middle = cleanedNumber.slice(2, 6);
    var tail = cleanedNumber.slice(6);
    var formattedNumber = "".concat(head).concat(separator).concat(middle).concat(separator).concat(tail);
    return formattedNumber;
};
var formatMobileNumberToInternal = function(mobileNo) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " ";
    // Remove any non-digit characters from the input string
    var cleanedNumber = mobileNo === null || mobileNo === void 0 ? void 0 : mobileNo.replace(/\D/g, "");
    if (cleanedNumber === null || cleanedNumber === void 0 ? void 0 : cleanedNumber.startsWith("66")) {
        cleanedNumber = cleanedNumber.replace("66", "0");
    }
    if ((cleanedNumber === null || cleanedNumber === void 0 ? void 0 : cleanedNumber.length) !== 10) {
        return mobileNo;
    }
    var head = cleanedNumber.slice(0, 2);
    var middle = cleanedNumber.slice(2, 6);
    var tail = cleanedNumber.slice(6);
    var formattedNumber = "".concat(head).concat(separator).concat(middle).concat(separator).concat(tail);
    return formattedNumber;
};
var formatNumberToThaiCurrency = function(number) {
    var hasDecimal = number % 1 !== 0;
    return number.toLocaleString("th-TH", {
        style: "currency",
        currency: "THB",
        maximumFractionDigits: hasDecimal ? 2 : 0,
        minimumFractionDigits: hasDecimal ? 2 : 0
    });
};
function snakeToCamelCase(str) {
    return str.replace(/([-_][a-z])/g, function(group) {
        return group.toUpperCase().replace("-", "").replace("_", "");
    });
}


/***/ }),

/***/ 65934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lt": function() { return /* binding */ filterParams; },
/* harmony export */   "YN": function() { return /* binding */ genPlanDirectLinkShareUrl; },
/* harmony export */   "j4": function() { return /* binding */ formatPathByLogicalGroupChannel; }
/* harmony export */ });
/* unused harmony export getUrlWithQuery */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var src_constants_params__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62090);
/* harmony import */ var src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85760);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable import/prefer-default-export */ 






var filterParams = function(params) {
    var includeList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : src_constants_params__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_PARAMS */ .g_;
    return Object.keys(params || {}).filter(function(key) {
        return includeList.includes(key);
    }).reduce(function(obj, key) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, obj), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, key, params[key]));
    }, {});
};
// we don't need /${channelPath} in retail
var formatPathByLogicalGroupChannel = function(path) {
    var logicalGroupChannel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_5__/* .LOGICAL_GROUP_CHANNEL_CODE */ .V;
    return logicalGroupChannel !== src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_5__/* .RETAIL_LOGICAL_GROUP_CHANNEL_CODE */ .b ? path : path.replace(/^\/?[^/]+/, "") || "/";
};
var genPlanDirectLinkShareUrl = function(param, lang) {
    var channelPath = param.channelPath, categoryCode = param.categoryCode, planCode = param.planCode, originUrl = param.originUrl, sRefCode = param.sRefCode;
    var utmQueryString = "".concat(src_constants_params__WEBPACK_IMPORTED_MODULE_1__/* .UTM_PARAMS.UTM_SOURCE */ .Yz.UTM_SOURCE, "=sharebutton&").concat(src_constants_params__WEBPACK_IMPORTED_MODULE_1__/* .UTM_PARAMS.UTM_MEDIUM */ .Yz.UTM_MEDIUM, "=healthplanpage&").concat(src_constants_params__WEBPACK_IMPORTED_MODULE_1__/* .UTM_PARAMS.UTM_CAMPAIGN */ .Yz.UTM_CAMPAIGN, "=").concat(planCode);
    var sRefCodeQueryString = sRefCode ? "&sRefCode=".concat(sRefCode) : "";
    var planDirectLinkPath = formatPathByLogicalGroupChannel("/".concat(channelPath, "/content-direct/").concat(categoryCode, "/plan/").concat(planCode, "?").concat(utmQueryString).concat(sRefCodeQueryString));
    var planDirectLinkUrl = "".concat(originUrl, "/").concat(lang).concat(planDirectLinkPath);
    return planDirectLinkUrl;
};
// only support simple flat query object
var getUrlWithQuery = function(path, query) {
    return "".concat(path).concat(isEmpty(query) ? "" : "?".concat(Object.entries(query).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], val = _param[1];
        return "".concat(key, "=").concat(val);
    }).join("&")));
};


/***/ })

}]);